import React from "react";
import CustomEmpty from "components/CustomEmpty";
import MainLayout from "components/Layouts/MainLayout";
import style from "./index.module.scss";
import useDeviceType from "Utils/useDeviceType";

interface CourseErrorProps {
    description?: string;
    breadcrumb?: React.ReactNode;
}

export default function CourseError({
    description,
    breadcrumb
}: CourseErrorProps) {
    const { isPC } = useDeviceType();

    return (
        <MainLayout title="提交投票" className={style.root}>
            {isPC && breadcrumb}

            <div className={style.main}>
                <CustomEmpty image="default" description={description} />
            </div>
        </MainLayout>
    );
}

CourseError.default = {
    description: "无内容"
};
